import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { storage } from "@/lib/storage";

/** Destination currency per country (ISO 4217). */
export const DEST_CUR = { AE: "AED", MA: "MAD", EG: "EGP", JO: "JOD", SA: "SAR", QA: "QAR", OM: "OMR", TN: "TND", BH: "BHD", KW: "KWD", LB: "LBP", IQ: "IQD", DZ: "DZD", LY: "LYD", SD: "SDG", MR: "MRU", SY: "SYP", YE: "YER", PS: "ILS", DJ: "DJF", SO: "SOS", KM: "KMF", EH: "MAD" };

/** Fetch-then-cache hook: returns the cached value immediately (works offline) and refreshes when online. */
export function useOfflineData(key, url) {
  const [data, setData] = useState(() => storage.getJSON(key, null));
  const [stale, setStale] = useState(false);
  useEffect(() => {
    let alive = true;
    axios.get(url).then(({ data: d }) => { if (!alive) return; storage.setJSON(key, d); setData(d); setStale(false); }).catch(() => alive && setStale(true));
    return () => { alive = false; };
  }, [key, url]);
  return { data, stale };
}

export const useSosKit = () => useOfflineData("atlas.kit.sos", `${API}/trip`);
export const useRates = (base = "EUR") => useOfflineData(`atlas.kit.rates.${base}`, `${API}/rates?base=${base}`);

export async function ocrImage(file, onProgress) {
  const Tesseract = (await import("tesseract.js")).default;
  const { data } = await Tesseract.recognize(file, "ara+eng", { logger: (m) => m.status === "recognizing text" && onProgress?.(m.progress) });
  return data.text.trim();
}

export async function translateText(text, target) {
  const { data } = await axios.post(`${API}/translate`, { text, target });
  return data.translation;
}
